"use client" 
import Link from "next/link"

const JobShareBox = ({job, lang}) => {
     return (
          <>
               <div className="dark:text-gray-300 p-4 text-center ">
                   
                   <Link target="_blank" href={`https://twitter.com/share?text=${job.job_title[lang]}%20position%20@talnethq%0Ahttps://talnet.co/jobs/${job.job_url}/?utm_source=twitter&utm_medium=jobshare`} className="twitter" 
onClick={(e) => {
     e.preventDefault(); // Prevent default link behavior
     window.open(
       e.currentTarget.href,
       '',
       'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
     );
   }}
                   >
                         {/* <img className="inline-block social-icons-2" src="/social-icons/twitter.svg" alt="Twitter"/> */}
                         <img className="inline-block social-icons-3" src="/social-icons/twitter.svg" alt="Twitter" />

                    </Link>

                    <Link target="_blank" href={`https://www.facebook.com/sharer.php?u=https://talnet.co/jobs/${job.job_url}/?utm_source=facebook&utm_medium=jobshare`}  className="facebook"  onClick={(e) => {
    e.preventDefault(); // Prevent default link behavior
    window.open(
      e.currentTarget.href,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
    );
  }} >
                    <img className="inline-block social-icons-3" src="/social-icons/facebook.svg" alt="Facebook" />
                    </Link>


                    <Link target="_blank" href={`https://www.linkedin.com/sharing/share-offsite/?url=https://talnet.co/jobs/${job.job_url}/?utm_source=linkedin&utm_medium=jobshare`} className="linkedin"  onClick={(e) => {
    e.preventDefault(); // Prevent default link behavior
    window.open(
      e.currentTarget.href,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
    );
  }} >
                    <img className="inline-block social-icons-3" src="/social-icons/linkedin.svg" alt="LinkedIn" />
                    </Link>

                    <Link href={`mailto:?subject=${job.job_title[lang]}%20@%20Talnet&body=https://talnet.co/jobs/${job.job_url}/?utm_source=email&utm_medium=jobshare`}>
                    <img className="inline-block social-icons-3" src="/social-icons/email.svg" alt="Email" />
                    </Link>

                   </div>
          </>
     )
}

export default JobShareBox